
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexgDjAsPVXyTQuO_xprRFX_EfdBUflESiD8z8w73aioh0Meta } from "/var/lib/jenkins/workspace/avia73.pro/pages/index.vue?macro=true";
import { default as privacyzil_Vcr9d_45QHAUtCDQCloQytR5wmDhaRyE8ifEO2a5cMeta } from "/var/lib/jenkins/workspace/avia73.pro/pages/privacy.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/var/lib/jenkins/workspace/avia73.pro/pages/index.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/var/lib/jenkins/workspace/avia73.pro/pages/privacy.vue")
  }
]